<template>
  <div class="box-detail accidentWarranty-wrapper">
    <div class="box-left">
      <div
        class="box-left-header"
        style="height: 50px;min-height: 50px;border-bottom: 1px solid #dfe3eb;display: flex;justify-content: space-between;align-items: center;"
      >
        <div
          @click="$router.push({ path: '/AccidentWarrantys' })"
          class="goBack"
          style="margin-top:0"
        >
          <i class="el-icon-arrow-left"></i>
          <span>出险质保</span>
          <i class="el-icon-s-custom"></i>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          label-position="top"
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
          :upload="upload"
          labelWidth="100px"
          :area="area"
          @changeForm="osg.changeForm"
        ></c-form>
      </div>
      <div class="box-left-footer" v-if="osg.has('AccidentWarranty.vue,edit')">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <!-- 动态 笔记 -->
    <div class="box-center">
      <el-tabs v-model="activeTab" class="c-h-1 c-flex c-flex-col">
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">{{ log.content }}</div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.createUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <!-- <el-collapse>
          <el-collapse-item>
            <template slot="title">
              <span>服务资源</span>
              <el-button
                v-if="!ServiceResource.relatedData.length"
                type="text"
                icon="el-icon-plus"
                @click.stop="addServiceResource"
              >
                添加服务资源
              </el-button>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                content="1个伙伴只允许关联1个服务资源"
                placement="top-end"
              >
                <i class="el-icon-info c-color-primary"></i>
              </el-tooltip>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of ServiceResource.relatedData" :key="i">
                <div>
                  <i class="el-icon-user-solid card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/ServiceResource/' + item._id" target="_blank">
                      资源名称：{{ item.name }}
                    </el-link>
                  </p>
                  <p>伙伴名称：{{ item.relatedName }}</p>
                  <p>资源类型：伙伴</p>
                  <p>当前位置：{{ item.lastKnownLocation }}</p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse> -->
        <el-collapse>
          <el-collapse-item v-if="false">
            <template slot="title">
              <span>人员列表</span>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of userList.relatedData" :key="i">
                <div>
                  <i class="el-icon-user-solid card-item-logo"></i>
                </div>
                <div>
                  <p>{{ item.name }}</p>
                  <p>
                    <el-link :href="'tel:' + item.phone" target="_blank">
                      <i class="el-icon-phone-outline"></i>
                      {{ item.phone }}
                    </el-link>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  name: 'accidentWarranty',
  data() {
    return {
      id: null,
      tenantId: '',
      collapse: false,
      formData: { gpsPoint: {}, exts: {}, foundTime: '' },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      fpi: {},
      options: {
        codecfg_accidentWarrantyType: { codeId: 'accidentWarrantyType' },
        codecfg_accidentWarrantyTypes: { codeId: 'accidentWarrantyTypes' },
        codecfg_industry: { codeId: 'INDUSTRY' }
      },
      rules: this.$util.rules,
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      contactList: [],
      //全部组织
      treeDataOptions: [],
      //人员列表
      userList: {
        relatedData: [],
        openEdit: false,
        formData: {}
      },
      //服务资源
      ServiceResource: {
        relatedData: [],
        openEdit: false,
        formData: {},
        searchObj: {},
        activeName: 'create'
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      }
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  mounted() {
    window.$this = this;
    this.id = this.osg.param('id');

    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = acount.tenantId;

    this.osg.getFields('accidentWarranty', () => {
      this.getData();
    });
    this.getLog();
    this.getNote();
    // this.getContact();
  },
  methods: {
    getContact() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 50,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.contactList = res.data;
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    //上传头像图片文件转base64
    getFileToBase64(file, fileList) {
      var that = this;
      const isJPG = file.raw.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.osg.toast('上传头像图片只能是 JPG 格式！', 'error');
        return;
      }
      if (!isLt2M) {
        this.osg.toast('上传头像图片大小不能超过 2MB！', 'error');
        return;
      }
      this.$util.Base64.imgFile(file.raw).then(res => {
        if (res) {
          that.formData.avatar = res;
          that.$forceUpdate();
        } else {
          this.osg.toast('上传失败', 'error');
        }
      });
    },
    getData() {
      let row;
      this.osg.ajax(`basic/accidentWarranty/findById/${this.id}.do`, {}, res => {
        row = this.$util.deepCopy(res.entity);
        if (row.exts) {
          for (let key in row.exts) {
            if (this.$util.isJson(row.exts[key])) {
              row.exts[key] = JSON.parse(row.exts[key]);
            }
          }
        }
        // row.description = [row.description];
        this.$util.renderExtField(this.extFields, row);
        this.formData = row;
        //获取属性修改记录
        this.getHistory();
        // this.getUserList();
      });
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveFormatExtField(this.extFields, this.formData);
        this.osg.ajax(
          'basic/accidentWarranty/upsert.do',
          { data: JSON.stringify(this.formData) },
          res => {
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'accidentWarranty',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'accidentWarranty'
        },
        res => {
          this.noteData = res || [];
        }
      );
    },
    //保存笔记
    saveNote() {
      var params = {
        //sid，smodul，content，id，isDelete(值Y) 保存传123,修改传1234,删除传12345
        sid: this.id,
        smodule: 'accidentWarranty',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, res => {
        this.osg.toast('保存成功！');
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    //获取人员列表
    getUserList() {
      let params = {
        'regex:orgIds|string#and': this.formData.orgId
      };
      this.osg.ajax('user/query.do', params, res => {
        if (res) {
          this.userList.relatedData = res.data;
        }
      });
    },
    //获取用户
    getUser(query) {
      let params = {
        page: 1,
        rows: 20,
        tenantId: this.tenantId,
        'regex:name|string#or': query
      };
      this.osg.ajax('user/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.user = res.data;
      });
    }
  }
};
</script>
<style scoped>
.accidentWarranty-wrapper >>> .el-icon-delete {
  display: none;
}
.accidentWarranty-wrapper >>> .el-icon-close-tip {
  display: none !important;
}
.accidentWarranty-wrapper >>> .el-upload--picture-card {
  display: none;
}
</style>
